/* A list query as a URL.
 *
 * Both paged lists — the jobs and the customers — ask their question in the
 * query string, and both have to say the same things the same way, because the
 * server reads them with the same coercing schema at the other end.
 *
 * Arrays go as comma-separated ids, which every one of them can be: a stage id
 * is a slug and a colour code has no commas in it. An empty array still goes —
 * "no stages" is a real answer and must count nothing, not everything — which
 * is why this tests for undefined rather than for falsy. */
export type QueryValue = string | number | boolean | string[] | undefined;

export function queryString(query: Record<string, QueryValue>): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined) continue;
    params.set(key, Array.isArray(value) ? value.join(',') : String(value));
  }
  const search = params.toString();
  return search ? `?${search}` : '';
}
